import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { PutOcrAccountsService } from "@/features/accounts/ocr/services/put-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { usePutOcrAccountStates } from "@/features/accounts/ocr/hooks/use-put-accounts-states";
import { useContext } from "react";
import { MoneyLinkError, MoneyLinkException, ErrorLevel } from "@/shared/utils/custom-exception";


export const usePutOcrAccounts = () => {
  const {
    ocrAccountId,
    setOcrAccountId,
    passbookName,
    setPassbookName,
    isShowErrorDialog,
    setIsShowErrorDialog,
  } = usePutOcrAccountStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const putOcrAccountsService = new PutOcrAccountsService();

  /*--------------------
    イベント関連
  --------------------*/
  // OCR口座情報更新
  const updateOcrAccounts = async (
    accountGroupId: string,
    ocrAccountId: string,
    passbookName: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await putOcrAccountsService.putOcrAccounts({
        account_group_id: accountGroupId,
        ocr_account_id: ocrAccountId,
        passbook_name: passbookName,
      });
      return true;
    } catch (error) {
      // エラーハンドリング
      console.log("updateOcrAccounts", error);
      if (
        error instanceof MoneyLinkException &&
        error.error.props.reason === "webmoneylink_parameter_error"
      ) {
        throw new MoneyLinkException({
          error: new MoneyLinkError({
            level: ErrorLevel.Warn,
            code: error.error.props.code,
            reason: error.error.props.reason,
            messageTitle: undefined,
            messageBody:
              "Web明細帳名に使用できない文字が含まれているか、文字数が上限を超えています。\n入力内容をご確認ください。",
          }),
        });
      }
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    ocrAccountId,
    setOcrAccountId,
    passbookName,
    setPassbookName,
    isShowErrorDialog,
    setIsShowErrorDialog,
    updateOcrAccounts: errorHandledAsync(updateOcrAccounts, setError),
  };
};
